import {
  StoreDetailMetaData,
  StoreDetailStructuredData,
} from '@jane/shared-ecomm/components';
import { useMenu } from '@jane/shared-ecomm/providers';
import { useEcommApp } from '@jane/shared/providers';

/**
 * MenuSeo sets the default meta details, title, description, url and open graph equivalents, for a store menu
 * This component is used in conjunction with MenuPageSeo which sets dynamic title and url
 * data for menu sub-pages
 */

export const MenuSeo = () => {
  const { isIframe } = useEcommApp();
  const {
    store,
    structuredData,
    appInfo: { appMode },
    paths,
  } = useMenu();

  return (
    <>
      {/* title and meta tags */}
      <StoreDetailMetaData
        appMode={appMode}
        isIframe={isIframe}
        paths={paths}
        store={store}
      />
      {/* structured json data */}
      <StoreDetailStructuredData
        store={store}
        structuredData={structuredData}
      />
    </>
  );
};
